import { TableViewDialog } from "../style";
import Select from "react-select";
import { Input, Label } from "reactstrap";
import { OptionImage } from "../../product/style";

const ErrorDialog = ({
                       header,
                       body,
                       cellWidth,
                       reloadItem
}) => {

  return (
    <TableViewDialog
      className={"error-dialog-dynamic-left border-danger"}
      onClick={(e) => {
        e.stopPropagation();
      }}
      style={{ padding: "0px", minWidth: "250px", minHeight: "100px" }}
    >
      <style>{`.error-dialog-dynamic-left {left: ${cellWidth}px !important; position: absolute;}`}</style>
      <div >
        <div className={"font-bold d-flex bg-pink p-2 flex-row justify-content-between"}>
          <span className={"text-danger fw-bold fs-14px"}>{header}</span>
          <span className={"fas fa-times pointer"}
                onClick={() => reloadItem()}
          ></span>
        </div>
        <div className={"p-2"}>
          {body}
        </div>
      </div>

    </TableViewDialog>
  );
};

export default ErrorDialog;
